import * as React from "react";
import SurfaceCard from "@/components/primitives/SurfaceCard";
import { SectionHead, StatGrid, hasStatValue } from "@/components/organization/kit";

interface Stat {
  label: React.ReactNode;
  value: string;
  icon?: "building" | "users" | "trending" | "location" | "dollar" | "home";
  subtext?: string;
}

interface QuickStatsGridProps {
  stats: Stat[];
}

const QuickStatsGrid = ({ stats }: QuickStatsGridProps) => {
  const items = stats.map((s) => ({ label: s.label, value: s.value || null, sub: s.subtext }));
  if (!items.some((s) => hasStatValue(s.value))) return null;
  return (
    <SurfaceCard padding="lg" className="rounded-2xl">
      <SectionHead kicker="By the numbers" title="The team at a glance" />
      <StatGrid items={items} cols={4} />
    </SurfaceCard>
  );
};

export default QuickStatsGrid;
